import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-primary-light/50 pt-24 pb-12 border-t border-primary-dark/5" data-id="element-73">
      <div className="container mx-auto px-6" data-id="element-74">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-20" data-id="element-75">
          <div className="lg:col-span-1" data-id="element-76">
            <div className="mb-6" data-id="element-77">
              <Link to="/" data-id="element-78">
                <img src="https://cdn.magicpatterns.com/uploads/gniRXuhgWi11P326tXmzet/accutemp-logo-colour.svg" alt="AccuTemp Air Conditioning" className="h-10 w-auto" data-id="element-79" />
              </Link>
            </div>
            <p className="text-xs text-primary-dark/60 leading-relaxed mb-8 max-w-xs" data-id="element-80">
              AccuTemp is the UK's trusted commercial air conditioning
              specialist. Headquartered in Coventry with nationwide coverage, we
              deliver installation, maintenance, and compliance services built
              to last.
            </p>
            <Link to="/contact" className="inline-block bg-primary-dark hover:bg-primary-dark/90 text-white text-sm px-6 py-2.5 rounded-full transition-colors" data-id="element-81">
              Contact us
            </Link>
          </div>

          <div data-id="element-82">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-83">
              Services
            </h4>
            <ul className="space-y-4 text-sm text-primary-dark/70" data-id="element-84">
              <li data-id="element-85">
                <Link to="/services/installation" className="hover:text-accent transition-colors" data-id="element-86">
                  Installation
                </Link>
              </li>
              <li data-id="element-87">
                <Link to="/services/maintenance" className="hover:text-accent transition-colors" data-id="element-88">
                  Maintenance
                </Link>
              </li>
              <li data-id="element-89">
                <Link to="/services/tm44" className="hover:text-accent transition-colors" data-id="element-90">
                  TM44 compliance
                </Link>
              </li>
              <li data-id="element-91">
                <Link to="/services/ventilation" className="hover:text-accent transition-colors" data-id="element-92">
                  Ventilation
                </Link>
              </li>
              <li data-id="element-93">
                <Link to="/services" className="hover:text-accent transition-colors" data-id="element-94">
                  All services
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-95">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-96">
              Company
            </h4>
            <ul className="space-y-4 text-sm text-primary-dark/70" data-id="element-97">
              <li data-id="element-98">
                <Link to="/about" className="hover:text-accent transition-colors" data-id="element-99">
                  About AccuTemp
                </Link>
              </li>
              <li data-id="element-100">
                <Link to="/why-accutemp" className="hover:text-accent transition-colors" data-id="element-101">
                  Why choose us
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/case-studies" className="hover:text-accent transition-colors" data-id="element-103">
                  Case studies
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/knowledge-hub" className="hover:text-accent transition-colors" data-id="element-105">
                  Resources
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/contact" className="hover:text-accent transition-colors" data-id="element-107">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-108">
            <h4 className="text-xs font-bold uppercase tracking-wider mb-6" data-id="element-109">
              Contact
            </h4>
            <div className="space-y-5" data-id="element-110">
              <a href="https://maps.google.com/?q=Justa+House+204-206+Holbrook+Lane+Coventry+CV6+4DD" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-111">
                <img src="https://cdn.magicpatterns.com/uploads/nNB1suhFNGfe5KE3vMugN2/contact-pin.svg" alt="" className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-112" />
                <span data-id="element-113">
                  Justa House, 204-206 Holbrook Lane,
                  <br data-id="element-114" />
                  Coventry, West Midlands, CV6 4DD
                </span>
              </a>
              <a href="https://linkedin.com/company/accutemp" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-115">
                <img src="https://cdn.magicpatterns.com/uploads/mWtzq8HpugEAB5Agb6tRuc/contact-linkedin.svg" alt="LinkedIn" className="w-5 h-5 flex-shrink-0" data-id="element-116" />
                <span data-id="element-117">Follow us on LinkedIn</span>
              </a>
              <a href="https://www.google.com/search?q=accutemp+air+conditioning+reviews" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-primary-dark/70 hover:text-accent transition-colors" data-id="element-118">
                <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-119">
                  <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-120" />
                  <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-121" />
                  <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-122" />
                  <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-123" />
                </svg>
                <span data-id="element-124">See our Google reviews</span>
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-primary-dark/10 text-xs text-primary-dark/50" data-id="element-125">
          <div className="mb-4 md:mb-0 space-y-1" data-id="element-126">
            <div data-id="element-127">Copyright © AccuTemp Air Conditioning Ltd 2026</div>
            <div className="text-[10px]" data-id="element-128">
              Company Reg No: 08651949 | VAT Reg No: 171 8012 29
            </div>
          </div>
          <div className="flex items-center gap-6" data-id="element-129">
            <Link to="/home-v2" className="hover:text-accent text-primary-dark/70 font-medium transition-colors" data-id="element-130">
              Home v2
            </Link>
            <a href="/cookies" className="hover:text-primary-dark transition-colors" data-id="element-131">
              Cookies
            </a>
            <a href="/privacy" className="hover:text-primary-dark transition-colors" data-id="element-132">
              Privacy policy
            </a>
            <a href="/gdpr" className="hover:text-primary-dark transition-colors" data-id="element-133">
              GDPR
            </a>
          </div>
        </div>
      </div>
    </footer>;
}